<template>
  <v-container class="c-claims app-bg">
    <v-layout column v-if="value">
      <v-flex v-for="item in value.claims" :key="item.name" v-if="value.code != 2017">
        <h3>{{ item.name }}</h3>
        <p v-html="item.content"></p>
      </v-flex>
      <p v-if="value.code == 2017" v-html="invoiceNotice"></p>
    </v-layout>
  </v-container>
</template>

<script>
import invoice from '@/assets/js/invoice'
export default {
  props: {
    value: Object,
  },
  data(){
    return {
      invoiceNotice: invoice,
    }
  }
};
</script>

<style lang="scss" scoped>
.c-claims {
  h3 {
    margin: 20px 0 5px;
  }
}
</style>
